import { RouteRecordRaw } from 'vue-router';

import LoginView from '@/views/login/LoginView.vue';
import NativeLoginSocialView from '@/views/login/NativeLoginSocialView.vue';
import NativeLoginUserSubView from '@/views/login/NativeLoginUserSubView.vue';
import SelfServiceLoginView from '@/views/login/SelfServiceLoginView.vue';

export default function loginRoutes(): RouteRecordRaw[] {
  return [
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      beforeEnter: (to, from, next) => {
        const { type = 'customer', ...restQuery } = to.query;

        if (restQuery.redirectTo) {
          return next();
        }

        const loginType = ['customer', 'dist'].includes(String(type)) ? type : 'customer';
        window.location.href = `${window.location.origin}/admin/login/${loginType}`;
        return false;
      },
    },
    // 셀프서비스 로그인
    {
      path: '/login/ss',
      name: 'login-ss',
      component: SelfServiceLoginView,
    },
    // 셀프서비스 추가사용자 로그인
    {
      path: '/login/ss/sub',
      name: 'login-ss-sub',
      component: SelfServiceLoginView,
    },
    // 앱 로그인
    {
      path: '/app/login',
      name: 'native-login',
      component: NativeLoginSocialView,
    },
    {
      path: '/app/adduse',
      name: 'native-adduse',
      component: NativeLoginUserSubView,
    },
    {
      path: '/login/:type/:partnerCode',
      name: 'login-partnerCode',
      redirect: (to) => ({
        path: '/login',
        query: { type: to.params.type, partnerCode: to.params.partnerCode },
      }),
    },
    // TODO: 추후  '/admin-login', '/dist/login', '/internal/login' 삭제
    {
      path: '/admin-login',
      name: 'admin-login',
      redirect: () => ({ path: '/login', query: { type: 'customer' } }),
    },
    {
      path: '/dist/login',
      name: 'dist-login',
      redirect: () => ({ path: '/login', query: { type: 'dist' } }),
    },
  ];
}
